import * as React from 'react';
import './formInput.module.scss';
import { observer } from 'mobx-react';
import classNames from 'classnames';

type FormInputProps = {
  type?: string;
  name: string;
  value: string;
  placeholder: string;
  onChange: () => void;
  error?: string;
  styleName?: string;
  className?: string;
};

export const FormInput = observer(({ type, name, value, placeholder, onChange, error, className }: FormInputProps) => {
  const formInputStyleNames = classNames('form-input', {
    'account-page-form-input': className?.includes('account-page-form-input'),
  });

  if (type === 'textarea') {
    return (
      <div styleName="form-input-wrapper" className={className}>
        <textarea
          styleName={formInputStyleNames}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
        {error && <div styleName="error">{error}</div>}
      </div>
    );
  }
  return (
    <div styleName="form-input-wrapper" className={className}>
      <input
        type={type || 'text'}
        styleName={formInputStyleNames}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
      {error && <div styleName="error">{error}</div>}
    </div>
  );
});
